<script>
  import { Router } from 'svelte-router-spa';
  import { routes } from './routes';
  import PopupInstall from './views/platform/iosInstall.svelte';
  import Modal from './views/widgets/modal.svelte';
  let isOnline = "";
</script>

<style>
  
   em {
     background: tomato;
     color: #fff;
     padding: 1em;
     text-align: center;
     display: block;
     position: relative;
      top: 0;
      left: 0;
      z-index: 1111111;
   }
   .wrapper {
     overflow: hidden;
     background: #00627d;

      background: linear-gradient(135deg, #00627d 0%,#00a7ae 100%);
	
   }
</style>

<svelte:head>
    
    <link rel="stylesheet" href="https://use.typekit.net/srx6hec.css">

    <!-- Google Tag Manager -->
    <script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-WVJTPSZ');</script>
    <!-- End Google Tag Manager -->


</svelte:head>

<svelte:window bind:online={isOnline}/>

{#if !isOnline}
<em>You are currently offline. The app experience may change based on this status.</em>
{/if}
<PopupInstall />
<div class="wrapper">
  <Modal>
    <Router {routes} />
  </Modal>
</div>